import { render, staticRenderFns } from "./ReductionProgress.vue?vue&type=template&id=15509cfe&scoped=true&"
import script from "./ReductionProgress.vue?vue&type=script&lang=js&"
export * from "./ReductionProgress.vue?vue&type=script&lang=js&"
import style0 from "./ReductionProgress.vue?vue&type=style&index=0&id=15509cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15509cfe",
  null
  
)

export default component.exports